import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { ATTRIBUTE_PORTAL, ATTRIBUTE_PORTAL_VALUE } from '@carnica/utils';
var INVALID_INDEX = 1;
var DEFAULT_INDEX = 500;
var isPortal = function isPortal(element) {
  var _element$dataset;
  return ((_element$dataset = element.dataset) === null || _element$dataset === void 0 ? void 0 : _element$dataset[ATTRIBUTE_PORTAL]) === ATTRIBUTE_PORTAL_VALUE;
};
export var useChangeZIndex = function useChangeZIndex() {
  var _useState = useState(DEFAULT_INDEX),
    _useState2 = _slicedToArray(_useState, 2),
    zIndex = _useState2[0],
    setZIndex = _useState2[1];

  // eslint-disable-next-line sonarjs/cognitive-complexity
  useEffect(function () {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.removedNodes.forEach(function (item) {
          var element = item;
          if (isPortal(element)) {
            setZIndex(DEFAULT_INDEX);
          }
        });
        mutation.addedNodes.forEach(function (item) {
          var element = item;
          if (isPortal(element)) {
            var portalIndex = Number(getComputedStyle(element).zIndex);
            var isInvalid = !portalIndex || Number.isNaN(portalIndex);
            var newIndex = isInvalid ? INVALID_INDEX : portalIndex - 1;
            setZIndex(newIndex);
          }
        });
      });
    });
    var target = document.querySelector('body');
    if (target) {
      observer.observe(target, {
        childList: true
      });
    }
    return function () {
      observer.disconnect();
    };
  }, []);
  return zIndex;
};